/* The end of a paged wall: the next page's button, the row of tile shapes its wait stands in, or
 * the line after the last page. Moved out of `/nagrania` on its second wall, the Forma gallery. */

.older {
  display: flex;
  flex-direction: column;
}

.olderButton {
  align-self: center;
  height: var(--h-clip-wall-action);
  padding: var(--space-0) var(--space-14px);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-semibold);
  background: transparent;
  border-radius: var(--radius-sm);
}

.notice {
  align-self: center;
  margin: var(--space-0);
  font-size: var(--fs-label-md);
  color: var(--text-2);
}

.end {
  margin: var(--space-0);
  font-size: var(--fs-label);
  color: var(--text-3);
  text-align: center;
}
